import { Button, useStyles } from '@archipro-design/aria';
import { useRef, useState } from 'react';
import { LocationDetailMobile } from '@modules/professional/component/contact-tab/LocationDetail.mobile';
import { NoSearchResult } from '@modules/professional/component/contact-tab/NoSearchResult';
import type {
    LocationDataType,
    ProfessionalInitialType,
} from '@modules/professional/type/contact-page-types';
import * as S from './ContactPage.mobile.style';
import { MOBILE_INITIAL_LOCATION_NUM } from './LocationConstant';

interface LocationsProps {
    locations: LocationDataType[];
    professional: ProfessionalInitialType;
    originLocationCount: number;
}

export const LocationListMobile: React.FC<LocationsProps> = ({
    locations,
    professional,
    originLocationCount,
}) => {
    const { css } = useStyles();
    const listSectionRef = useRef<HTMLDivElement>(null);
    const [displayLocationCount, setDisplayLocationCount] = useState(
        MOBILE_INITIAL_LOCATION_NUM,
    );

    return (
        <>
            {originLocationCount > 0 && (
                <div
                    className={css(S.LocationListSection)}
                    ref={listSectionRef}
                >
                    {locations.length > 0 ? (
                        <>
                            {locations
                                .slice(0, displayLocationCount)
                                .map((location, index) => (
                                    <LocationDetailMobile
                                        key={index}
                                        location={location}
                                        professional={professional}
                                    />
                                ))}

                            {locations.length > displayLocationCount && (
                                <div className={css(S.ContentWrapper)}>
                                    <Button
                                        color="dark"
                                        onClick={() => {
                                            setDisplayLocationCount(
                                                displayLocationCount +
                                                    MOBILE_INITIAL_LOCATION_NUM,
                                            );
                                        }}
                                        size={18}
                                        className={css(S.LoadMoreButton)}
                                    >
                                        LOAD MORE
                                    </Button>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className={css(S.ContentWrapper)}>
                            <NoSearchResult />
                        </div>
                    )}
                </div>
            )}
        </>
    );
};
